/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  pageHeading: {
    id: "b2b.provozni-informace.page-heading",
    defaultMessage: "Operational information management"
  },
  pageHeadingFilter: {
    id: "b2b.provozni-informace.page-heading.action-filter",
    defaultMessage: "Filter"
  },
  pageHeadingAdd: {
    id: "b2b.provozni-informace.page-heading.action-add",
    defaultMessage: "New information"
  }
});

export default () => useMessages(MESSAGES);
